// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2cPGa","label":"Completed_label__27BDM"};